import React, { Fragment, useState } from 'react'
import { useQuery } from 'react-query'
import axios from 'axios'

import { ReactComponent as Spinner } from '../../images/icons/spinner.svg'
import { Icon } from '../../components'
import { toast } from 'react-toastify'

const Row = ({ item, hasFieldsCSV }) => {
  const [inProgress, setProgress] = useState(false)
  const onClick = async () => {
    try {
      setProgress(true)
      const res = await axios.get(
        '/api/migration/convert_template?fileName=' + item.fileName)
      if (typeof res.data === 'string' && res.data.startsWith('ERROR:')) {
        // an error occurred when thansforming the uploaded DOCX...
        // display to user (todo: where?) and ABORT download
        toast.error(
          <div>
            {res.data}
          </div>, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 5000,
          })
      }
      const url = res.data
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', item.templateName
        ? (item.templateName + '.docx')
        : item.fileName,
      )
      document.body.appendChild(link)
      link.click()

    } catch (e) {

    } finally {
      setProgress(false)
    }
  }

  return (<div className={'row'} key={item.fileName}>
    <div className={'col-3'}>
      <label
        className={'d-block my-3'}>{item.fileName}</label>
    </div>
    <div className={'col-3'}>
      <label
        className={'d-block my-3'}>{item.templateName}</label>
    </div>
    <div className="col-2">
      <button
        className={'btn btn-secondary btn-block p-1 btn-theme my-2'}
        onClick={onClick}
        disabled={!hasFieldsCSV || inProgress}
      >{inProgress ? <Spinner className={'rot'} style={{
        width: 30,
        top: -4,
        position: 'relative',
      }}/> : (<Fragment>
        <Icon type="icon-download1" style={{
          fontSize: '1rem',
          verticalAlign: '0.15em',
        }}/> Download
      </Fragment>)}
      </button>
    </div>
  </div>)
}

const ConvertTemplates = () => {
  const {
    data: templates,
    isLoading: isLoadingTemplates,
  } = useQuery('/api/migration/import_templates',
    async () => {
      const { data } = await axios.get('/api/migration/import_templates')
      return data
    }, {
      retry: false,
    })

  const {
    data: hasFieldsCSV,
    isLoading: isLoadingHasFieldsCSV,
  } = useQuery('/api/migration/has_fields_csv',
    async () => {
      const { data } = await axios.get('/api/migration/has_fields_csv')
      return data
    }, {
      retry: false,
    })

  if (isLoadingTemplates || isLoadingHasFieldsCSV) {
    return <div className={'row knackly-plain py-2 ml-0'}>
      <div className={'col-2'}>Loading...</div>
    </div>
  }

  return (
    <div className={'row knackly-plain py-2 ml-0'}>
      <div className={'col-3'}><label
        className={'d-inline'}>HotDocs File Name</label></div>
      <div className={'col-3'}><label
        className={'d-inline'}>New Template Name</label></div>
      <div className="col-2">
        <label
          className={'d-inline'}></label>
      </div>
      <div className={'col-12'}>
        {templates.map(
          item => (<Row item={item} hasFieldsCSV={hasFieldsCSV}/>))}
      </div>
    </div>
  )
}

export default ConvertTemplates
